<pbc-sorter [config]="RechnungsVorlagenSorterConfig" [sorter]="rechnungsVorlagen.sorter$ | async" (sorterChange)="rechnungsVorlagen.sorter$.next($event)"></pbc-sorter>
